import React from 'react';
import { IoChevronBackOutline } from 'react-icons/io5';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

function CheckEmail() {
  const navigate = useNavigate();


  return (
    <div className='w-[90%] md:w-[70%] h-screen flex mx-auto items-center'>
        <div className="flex flex-col text-center mx-auto ">
        <img src="/images/mail.png" className='mx-auto w-[150px] mb-5 '/>
      <h2 className="text-lg font-semibold text-primary mb-4"><FormattedMessage id="email_sent" defaultMessage={"We sent you an email!"} /></h2>
      <p className="mb-6 text-t-light"><FormattedMessage id="check_email_desc" defaultMessage={"Please check your email inbox and click on the provided link to set you password"} />.</p>
      <button
    onClick={() => navigate('/login')}
        className=""
      >
        <p className="flex gap-x-2 text-t-light justify-self-center items-center">
        <IoChevronBackOutline />
        <FormattedMessage id="back_to_login" defaultMessage={"Back to Login"} />

        </p>
      </button>
    </div>
    </div>
  );
}

export default CheckEmail;
